(() => {
  // app/scripts/product-card-slide.js
  var productCardSlideHover = class extends HTMLElement {
    constructor() {
      super();
      window.addEventListener("DOMContentLoaded", function() {
        this.smallScreen = 575;
        this.finished = true;
        this.init();
      });
    }
    connectedCallback() {
      if (this.finished)
        return;
      this.smallScreen = 575;
      this.finished = true;
      this.init();
    }
    init() {
      this.queryBtn();
      this.setSlide();
      this.onClick();
      this.showImages();
      this.preload2ndImage();
      this.listenScrollMob();
      this.initFirstAnimate();
    }
    initFirstAnimate() {
      if (window.innerWidth < this.smallScreen) {
        this.style.gap = "4px";
        setTimeout(() => {
          this.slides.forEach((slide, index) => {
            slide.style.transform = `translateX(-30px)`;
          });
          setTimeout(() => {
            this.slides.forEach((slide, index) => {
              slide.style.transform = `translateX(0)`;
            });
          }, 850);
        }, 800);
      }
    }
    setSlide() {
      this.slides = this.querySelectorAll("picture-component");
      this.progress = this.querySelector(".js-progress");
      this.currentIndex = 1;
      this.totalSlides = this.slides.length;
      this.setActiveSlide();
    }
    setActiveSlide() {
      let percent = (this.currentIndex - 1) * -100;
      this.slides.forEach((slide, index) => {
        slide.style.transform = `translateX(${percent}%)`;
      });
      let progressWidth = (this.currentIndex - 1) * 100;
      this.progress.style.transform = `translateX(${progressWidth}%)`;
      this.checkEndSlide();
    }
    showImages() {
      this.slides.forEach((slide, index) => {
        let picture = slide.querySelector("picture");
        if (picture)
          picture.style.display = "block";
      });
    }
    preload2ndImage() {
      if (this.slides[1]) {
        let img = new Image();
        img.src = this.slides[1].querySelector("img").src;
      }
    }
    listenScrollMob() {
      let _this = this;
      if (!this.progress)
        return;
      this.progress.style.width = `${1 / this.totalSlides * 100}%`;
      _this.addEventListener("scroll", () => {
        let scrollLeft = this.scrollLeft;
        let imageWidth = this.slides[0].offsetWidth;
        let progressWidth = scrollLeft / imageWidth * 100;
        _this.progress.style.transform = `translateX(${progressWidth}%)`;
        _this.currentIndex = parseInt(Math.round(scrollLeft / imageWidth));
      });
    }
    onClick() {
      if (!this.slides.length || this.slides.length <= 1)
        return;
      this.btnPrev?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.currentIndex > 1) {
          this.currentIndex--;
        }
        this.setActiveSlide();
      });
      this.btnNext?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.currentIndex < this.totalSlides) {
          this.currentIndex++;
        }
        this.setActiveSlide();
      });
    }
    checkEndSlide() {
      if (!this.slides.length || this.slides.length <= 1)
        return;
      if (this.currentIndex === this.totalSlides) {
        this.btnNext?.classList.add("disabled");
        this.btnPrev?.classList.remove("disabled");
        return;
      }
      if (this.currentIndex === 1) {
        this.btnNext?.classList.remove("disabled");
        this.btnPrev?.classList.add("disabled");
        return;
      }
      this.btnNext?.classList.remove("disabled");
      this.btnPrev?.classList.remove("disabled");
    }
    queryBtn() {
      this.slides = this.slides || this.querySelectorAll("picture-component");
      if (!this.slides.length || this.slides.length <= 1)
        return;
      let btns = `<div class="pd-card-slide__controls">
              <button class="btn btn--prev" type="button" title="Previous" aria-label="Previous">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"></path></svg>
              </button>
              <button class="btn btn--next" type="button" title="Next" aria-label="Next">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><title>icon-chevron</title><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"></path></svg>
              </button>
            </div>`;
      let btnsExisted = this.querySelector(".pd-card-slide__controls");
      if (!btnsExisted) {
        this.innerHTML += btns;
      }
      ;
      this.btnPrev = this.querySelector(".btn--prev");
      this.btnNext = this.querySelector(".btn--next");
    }
  };
  customElements.define("product-card-slide", productCardSlideHover);
})();
